import React, { useState } from "react";
import { useCart } from "../../../../context/cartContext";
import { useAuth } from "../../../../context/authContext";
import styles from "./MiniCart.module.css";
import { useNavigate } from "react-router-dom";
import noImagePlaceholder from "../../../../assets/img/not-image.png";

const formatCurrency = (value) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export default function MiniCart() {
  const {
    items,
    isOpen,
    closeCart,
    removeItem,
    getTotal,
  } = useCart();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showAuthWarning, setShowAuthWarning] = useState(false);

  if (!isOpen) return null;

  const total = getTotal();

  const handleCheckout = () => {
    if (!isAuthenticated) {
      setShowAuthWarning(true);
      setTimeout(() => setShowAuthWarning(false), 3000);
      return;
    }
    closeCart();
    navigate("/carrito");
  };

  const handleGoToLogin = () => {
    closeCart();
    navigate("/auth", { state: { from: "/carrito", message: "Inicia sesión para completar tu compra" } });
  };

  return (
    <>
      <div className={styles.overlay} onClick={closeCart} />

      <div className={styles.miniCart}>
        <div className={styles.header}>
          <span className={styles.title}>Mi carrito de compras</span>
          <button className={styles.closeBtn} onClick={closeCart}>X</button>
        </div>

        <div className={styles.items}>
          {items.length === 0 ? (
            <div className={styles.emptyState}>
              <span className={styles.emptyIcon}>&#128722;</span>
              <p>Tu carrito esta vacio</p>
              <span className={styles.emptySubtext}>Agrega billetes de loteria!</span>
            </div>
          ) : (
            items.map((item) => (
              <div key={item.id} className={styles.item}>
                <div className={styles.itemImage}>
                  <img 
                    src={item.imagen || noImagePlaceholder} 
                    alt={item.loteria}
                    onError={(e) => { e.target.src = noImagePlaceholder; }}
                  />
                </div>

                <div className={styles.itemContent}>
                  <div className={styles.itemHeader}>
                    <span className={styles.itemType}>Billete de Loteria</span>
                    <button 
                      className={styles.deleteBtn}
                      onClick={() => removeItem(item.id)}
                      title="Eliminar"
                    >&#128465;</button>
                  </div>
                  
                  <h4 className={styles.itemName}>{item.loteria}</h4>
                  
                  <div className={styles.itemDetails}>
                    <span>No. {item.numero}</span>
                    <span>Serie {item.series}</span>
                  </div>
                  
                  <div className={styles.itemFracciones}>
                    {item.cantidad} {item.cantidad === 1 ? 'fracción' : 'fracciones'}
                  </div>

                  <div className={styles.itemFooter}>
                    <span className={styles.pricePerFraccion}>
                      {formatCurrency(item.precio || 0)} c/u
                    </span>
                    <span className={styles.itemPrice}>
                      {formatCurrency((item.precio || 0) * (item.cantidad || 1))}
                    </span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <div className={styles.footer}>
            {showAuthWarning && (
              <div className={styles.authWarning}>
                <p>Debes iniciar sesión para comprar</p>
                <button className={styles.loginBtn} onClick={handleGoToLogin}>
                  Iniciar sesión
                </button>
              </div>
            )}
            
            <div className={styles.summaryRow}>
              <span>Total</span>
              <span className={styles.totalValue}>{formatCurrency(total)}</span>
            </div>

            <div className={styles.actions}>
              <button
                className={styles.viewCartBtn}
                onClick={() => { closeCart(); navigate("/carrito"); }}
              >Ver carrito</button>

              <button
                className={styles.checkoutBtn}
                onClick={handleCheckout}
              >Comprar ahora</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}